import { useMemo } from "react";
import { SiteId } from "@visioni/a3s-schema";
import { useSites } from "./useSites";

export function useSiteNames(): ReadonlyMap<string, string> | undefined {
  const { sites } = useSites();

  return useMemo(() => {
    if (!sites) return undefined;
    return new Map(sites.map((s) => [SiteId.toString(s.siteId), s.siteName]));
  }, [sites]);
}
